import {
  DataPersonEntityRaw,
  dataPersonEntityRaw,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataPersonsListResponseDTO {
  private static validation = Validate.compile(
    DataPersonsListResponseDTO.validationSchema()
  );

  constructor(readonly data: DataPersonsListResponseDTORaw) {
    Validate.assert(DataPersonsListResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['dataPersons', 'count'],
      properties: {
        dataPersons: {
          type: 'array',
          items: dataPersonEntityRaw,
        },
        count: {
          type: 'number',
          minimum: 0,
          maximum: Number.MAX_SAFE_INTEGER,
        },
      },
    };
  }
}

interface DataPersonsListResponseDTORaw {
  dataPersons: DataPersonEntityRaw[];
  count: number;
}
